import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-related-websites',
  templateUrl: './related-websites.component.html',
  styleUrls: ['./related-websites.component.css']
})
export class RelatedWebsitesComponent implements OnInit {
  title="Related Websites";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/main/related-websites/related-websites.component.ts